import { ProtestActAmountData } from 'chaika-frontend-types/frontend-cms';
import { LongList } from '@store/abstract/LongList';

interface FilterParams {}

export class ProtestAmountList extends LongList<ProtestActAmountData, ProtestActAmountData, FilterParams> {
    protected readonly identifiableFieldName: string = 'actId';

    protected create(params: ProtestActAmountData): ProtestActAmountData {
        return params;
    }
}
